import React from 'react';
import { Phone, Mail, HelpCircle, MessageCircle } from 'lucide-react';

const Support = () => {
  const callSupport = () => {
    window.open('tel:+919388893888', '_self');
  };

  const mailSupport = () => {
    window.open('mailto:hello@roadserve.app', '_self');
  };

  const faqs = [
    {
      question: 'How do I book a service?',
      answer: 'You can book a service through the Services tab. Select your preferred service type and schedule a convenient time.',
    },
    {
      question: 'Can I cancel my booking?',
      answer: 'Yes, you can cancel your booking up to 2 hours before the scheduled time. Go to your orders and click cancel.',
    },
    {
      question: 'Do you offer pickup & drop?',
      answer: 'Yes, we offer free pickup and drop service for most services. This will be mentioned during booking.',
    },
    {
      question: 'What payment methods do you accept?',
      answer: 'We accept cash, UPI, credit/debit cards, and digital wallets. Payment can be made online or cash on delivery.',
    },
    {
      question: 'How long does a service take?',
      answer: 'Service duration varies by type. Basic services take 1-2 hours, while comprehensive services may take 3-4 hours.',
    },
  ];

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-3xl font-bold text-gray-900">Help & Support</h1>
        <p className="text-gray-600 mt-1">We're here to help you 7 days a week</p>
      </div>

      {/* Contact Options */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <button
          onClick={callSupport}
          className="bg-cyan-50 hover:bg-cyan-100 p-6 rounded-xl border border-cyan-200 text-left transition"
        >
          <div className="flex items-center space-x-3 mb-2">
            <Phone size={24} className="text-cyan-600" />
            <h3 className="font-semibold text-gray-900">Call Support</h3>
          </div>
          <p className="text-gray-700">+91 93888 93888</p>
          <p className="text-sm text-gray-600 mt-1">Available 24/7</p>
        </button>

        <button
          onClick={mailSupport}
          className="bg-indigo-50 hover:bg-indigo-100 p-6 rounded-xl border border-indigo-200 text-left transition"
        >
          <div className="flex items-center space-x-3 mb-2">
            <Mail size={24} className="text-indigo-600" />
            <h3 className="font-semibold text-gray-900">Email Support</h3>
          </div>
          <p className="text-gray-700">hello@roadserve.app</p>
          <p className="text-sm text-gray-600 mt-1">We'll respond within 24 hours</p>
        </button>
      </div>

      {/* FAQs */}
      <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
        <div className="flex items-center space-x-2 mb-4">
          <HelpCircle size={24} className="text-purple-600" />
          <h2 className="text-xl font-bold text-gray-900">Frequently Asked Questions</h2>
        </div>
        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="p-4 bg-gray-50 border border-gray-200 rounded-lg"
            >
              <h3 className="font-semibold text-gray-900 mb-2">{faq.question}</h3>
              <p className="text-sm text-gray-600">{faq.answer}</p>
            </div>
          ))}
        </div>
      </div>

      {/* Chat Support */}
      <div className="bg-gradient-to-r from-blue-500 to-purple-600 rounded-xl p-6 text-white">
        <div className="flex items-center space-x-3 mb-2">
          <MessageCircle size={24} />
          <h2 className="text-xl font-bold">Need Immediate Help?</h2>
        </div>
        <p className="text-white/90 mb-4">
          Chat with our support team for instant assistance
        </p>
        <button
          onClick={() => alert('Chat feature coming soon!')}
          className="px-4 py-2 bg-white text-blue-600 rounded-lg hover:bg-gray-100 font-semibold"
        >
          Start Chat
        </button>
      </div>
    </div>
  );
};

export default Support;

